import * as React from 'react';
export var MemberCard = function (_a) {
    var image = _a.image, title = _a.title, role = _a.role, _b = _a.socials, socials = _b === void 0 ? [] : _b;
    return (React.createElement("div", { className: "card member-card text-center" },
        React.createElement("div", { className: "image" },
            React.createElement("img", { src: image, alt: typeof title === 'string' ? title : 'Member' })),
        React.createElement("h5", null, title),
        React.createElement("div", { className: "role" },
            React.createElement("small", null, role)),
        React.createElement("div", { className: "social" }, socials.map(function (_a, i) {
            var name = _a.name, icon = _a.icon, link = _a.link;
            return (React.createElement("a", { key: "".concat(name, "-").concat(i), title: name, href: link, target: "_blank" },
                React.createElement("i", { className: icon })));
        }))));
};
//# sourceMappingURL=index.js.map